<template>
  <div>
    <el-tabs type="border-card"  v-model="activeName">
      <el-tab-pane label="生产实绩(面积)" name="area" :lazy="true">
        <AssemblyProduceAchievementArea v-if="this.activeName === 'area'"></AssemblyProduceAchievementArea>
      </el-tab-pane>
      <el-tab-pane label="生产实绩(单元数)" name="unitNum" :lazy="true">
        <AssemblyProduceAchievementUnitNum v-if="this.activeName === 'unitNum'"></AssemblyProduceAchievementUnitNum>
      </el-tab-pane>
      <el-tab-pane label="生产性" name="productive" :lazy="true">
        <AssemblyProductive v-if="this.activeName === 'productive'"></AssemblyProductive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AssemblyProductive from "@/views/applications/bus/make_schedule/AssemblyProductive";
import AssemblyProduceAchievementArea from "@/views/applications/bus/make_schedule/AssemblyProduceAchievementArea";
import AssemblyProduceAchievementUnitNum
  from "@/views/applications/bus/make_schedule/AssemblyProduceAchievementUnitNum";

export default {
  name: "AssemblyProduceAchievement",
  components: {AssemblyProductive,AssemblyProduceAchievementArea,AssemblyProduceAchievementUnitNum},
  data() {
    return {
      activeName: 'area',

    }
  }, methods: {

  },
  mounted() {

  },
  created() {
  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}
</style>